import styled from 'styles/styled';

export const OptionButton = styled.button<{ selected: boolean }>`
  width: 100%;
  min-height: 58px;
  padding: 8px 12px;
  border-radius: 10px;
  border: 1px solid ${({ selected }) => (selected ? '#52D381' : '#34373C')};
  background-color: #292B2E;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  cursor: pointer;
  transition: border-color 200ms ease-in, color 200ms ease-in;
  color: ${({ selected }) => (selected ? '#52D381' : '#EFEFEF')};
  font-family: inherit;

  &:hover {
    border-color: ${({ selected }) => (selected ? '#52D381' : '#5C6168')};
  }
`;

export const Label = styled.span`
  font-size: 16px;
  font-weight: 500;
  line-height: 18px;
  font-variant-numeric: tabular-nums;
`;

export const UsdValue = styled.span<{ selected?: boolean }>`
  font-size: 10px;
  font-weight: 300;
  line-height: 13px;
  color: ${({ selected }) => (selected ? '#A7A8B2' : '#7A7E8C')};
  font-variant-numeric: tabular-nums;
`;

export const CachedLabel = styled.span`
  margin-left: 4px;
  font-size: 9px;
  font-weight: 400;
  font-style: italic;
  color: #8A9199;
`;
